module.exports = __webpack_public_path__ + "img/viviane-kogler.fa9382ea.jpg";